import useHttp from './useHttp';
import { useAuth } from '../context/authContext';

// Hook to access Bon (POS receipts) endpoints
const useBon = () => {
  const authCtx = useAuth();
  const { sendRequest } = useHttp();

  // Build default headers including auth/device tokens
  const getHeaders = (withDevice = false) => authCtx.getAuthHeaders({ withAuth: true, withDevice });

  // POST /api/v1/bon/viewformat
  const getBonView = async ({
    from,
    to,
    branches = [],
    entertainments = [],
    includeDetails = false,
    includeOnline = false,
  }) => {
    return await sendRequest({
      url: '/api/v1/bon/viewformat',
      method: 'POST',
      headers: { ...getHeaders(), 'Content-Type': 'application/json' },
      body: { from, to, branches, entertainments, includeDetails, includeOnline },
    });
  };

  // GET /api/v1/bon/list (paginated)
  const getBonList = async ({
    page = 1,
    limit = 25,
    branchId,
    entertainmentTypeId,
    type = 'all',
    from,
    to,
    receiptNumber,
  }) => {
    const params = { page, limit, type };
    if (branchId) params.branchId = branchId;
    if (entertainmentTypeId) params.entertainmentTypeId = entertainmentTypeId;
    if (from) params.from = from;
    if (to) params.to = to;
    if (receiptNumber) params.receiptNumber = receiptNumber;
    return await sendRequest({
      url: '/api/v1/bon/list',
      method: 'GET',
      headers: getHeaders(),
      params,
    });
  };

  // GET /api/v1/bon/:id/details
  const getBonDetails = async bonId => {
    return await sendRequest({
      url: `/api/v1/bon/${bonId}/details`,
      method: 'GET',
      headers: getHeaders(),
    });
  };

  // POST /api/v1/bon/:id/convert-to-invoice
  const convertBonToInvoice = async (bonId, payload) => {
    return await sendRequest({
      url: `/api/v1/bon/${bonId}/convert-to-invoice`,
      method: 'POST',
      headers: { ...getHeaders(), 'Content-Type': 'application/json' },
      body: payload,
      requiredRights: ['bon:convert'],
      successToastMessage: 'Rechnung wurde erstellt',
    });
  };

  return { getBonView, getBonList, getBonDetails, convertBonToInvoice };
};

export default useBon;
